import styled from 'styled-components';

import { ItemText } from '@components/ui/search/SearchResultListStyle';
export const SelectWrapper = styled.div<{ isHeaderOpen?: boolean }>`
  position: relative;
  margin: ${({ isHeaderOpen }) => (isHeaderOpen ? '20px' : '0px')};
`;

export const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ErrorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
`;

export const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #f79c7f;
`;

export const ErrorMessage = styled.div`
  white-space: nowrap;
  background-color: #f79c7f;
  font-size: 10px;
  color: #602410;
  font-weight: 400;
  padding: 3px 6px;
`;

export const ItemErrorText = styled(ItemText)`
  color: rgb(226, 35, 27);
  font-size: 14px;
  overflow-wrap: inherit;
`;
export const InputWrapper = styled.div`
  &:focus {
    outline: none;
  }
`;
